module.exports = __webpack_public_path__ + "img/logo.b45c4491.png";